/**
 * SHA-256 hashes a filename to a hex digest.
 *
 * Used to anonymize file names before they leave the browser in confidential
 * (private) mode — both for analytics and for the confidential usage telemetry
 * persisted to our database. The raw name never reaches the server.
 */
export async function hashFileName(fileName: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(fileName);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}
